import { action } from "satcheljs";

const toggleHideOpenShiftRows = action(
    "toggleHideOpenShiftRows",
    () => ({})
);

export default toggleHideOpenShiftRows;